import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const AdminTourContext = createContext({
  currentTour: null,
  setCurrentTour: () => {},
});

export function AdminTourProvider({ children }) {
  const [currentTour, setCurrentTour] = useState(null);

  const value = useMemo(
    () => ({
      currentTour,
      setCurrentTour,
    }),
    [currentTour],
  );

  return <AdminTourContext.Provider value={value}>{children}</AdminTourContext.Provider>;
}

export function useAdminTour() {
  const context = useContext(AdminTourContext);
  if (!context) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('useAdminTour used outside an AdminTourProvider; falling back to a no-op context.');
    }
    return {
      currentTour: null,
      setCurrentTour: () => {},
    };
  }
  return context;
}

export function useAdminTourRegistration({ id, label, openTour, enabled, routeKey }) {
  const { setCurrentTour } = useAdminTour();

  useEffect(() => {
    if (!enabled || !id || typeof openTour !== 'function' || !routeKey) {
      setCurrentTour((previous) => (previous?.id === id ? null : previous));
      return undefined;
    }

    setCurrentTour({
      id,
      routeKey,
      label: label || 'Tour',
      openTour,
    });

    return () => {
      setCurrentTour((previous) => (previous?.id === id ? null : previous));
    };
  }, [enabled, id, label, openTour, routeKey, setCurrentTour]);
}
